<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<!-- Modal -->

<div class="modal-content border-0">
  <div class="modal-header">
    <div class="modal-title" id="exampleModalLongTitle">{{ title }}</div>
    <button
      type="button"
      class="close btn-close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="userRoleForm" (submit)="handleRoles()">
    <div class="modal-body">
      <div id="viewModalContent" class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <form name="addUser" class="form-horizontal" novalidate>
              <div *ngIf="isAddOrEdit()">
                <fieldset>
                  <legend class="mb-4">User Info</legend>
                  <div class="form-group fieldIsRequired">
                    <label class="col-md-4 control-label" for="practicestaffId">
                      User ID
                    </label>
                    <div class="col-md-12">
                      <input
                        class="form-control"
                        type="number"
                        formControlName="practiceStaffId"
                        id="practicestaffId"
                        [ngClass]="{
                          'is-invalid':
                            userRoleControls.practiceStaffId.invalid &&
                            userRoleControls.practiceStaffId.touched,
                          cursorDisable: isEdit()
                        }"
                      />
                      <div
                        class="formValidationMessage"
                        role="alert"
                        *ngIf="
                          userRoleControls.practiceStaffId.invalid &&
                          userRoleControls.practiceStaffId.touched
                        "
                      >
                        <div
                          class="text-danger"
                          *ngIf="
                            userRoleControls.practiceStaffId.errors?.required
                          "
                        >
                          Field is required.
                        </div>
                        <div
                          class="text-danger"
                          *ngIf="
                            userRoleControls.practiceStaffId.errors?.maxlength
                          "
                        >
                          Max length is 12
                        </div>
                        <div
                          class="text-danger"
                          *ngIf="
                            userRoleControls.practiceStaffId.errors?.pattern
                          "
                        >
                          Field value must be number. Please provide correct
                          value.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-md-4 control-label" for="userName">
                      User Name
                    </label>
                    <div class="col-md-12">
                      <input
                        class="form-control"
                        type="text"
                        formControlName="userName"
                        id="userName"
                        [ngClass]="{
                          'is-invalid':
                            userRoleControls.userName.invalid &&
                            userRoleControls.userName.touched
                        }"
                      />
                      <div
                        class="formValidationMessage"
                        role="alert"
                        *ngIf="
                          userRoleControls.practiceStaffId.invalid &&
                          userRoleControls.practiceStaffId.touched
                        "
                      >
                        <div
                          class="text-danger"
                          *ngIf="userRoleControls.userName.errors?.required"
                        >
                          Field is required.
                        </div>
                        <div
                          class="text-danger"
                          *ngIf="userRoleControls.userName.errors?.maxlength"
                        >
                          Max length is 99.
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>

                <fieldset *ngIf="merchantUserRoles.value.length > 0">
                  <legend class="fieldIsRequired mb-3">
                    <span>Roles</span>
                  </legend>
                  <div class="form-group">
                    <div
                      class="row m-auto"
                      formArrayName="merchantUserRoles"
                      *ngFor="
                        let role of merchantUserRoles.controls;
                        let indexOf = index
                      "
                    >
                      <label
                        class="col-md-6 control-label m-auto bold-label"
                        for="role_{{ arrOfRoles[indexOf].value }}"
                      >
                        {{ arrOfRoles[indexOf].name }}
                      </label>
                      <div class="col-md-6 checkbox-option">
                        <input
                          type="checkbox"
                          (change)="updateRole(indexOf)"
                          [formControlName]="indexOf"
                          id="role_{{ arrOfRoles[indexOf].value }}"
                        />
                      </div>
                    </div>
                    <div
                      class="formValidationMessage"
                      role="alert"
                      *ngIf="
                        userRoleForm.invalid &&
                        userRoleControls.merchantUserRoles.touched
                      "
                    >
                      <div
                        class="text-danger"
                        *ngIf="merchantUserRoles.errors?.required"
                      >
                        At least one role must be selected.
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div *ngIf="isRemove()">
                <p>
                  Do you really want to remove user with id
                  {{ merchantUser?.practicestaffId }} and all assigned roles?
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="close()"
        data-dismiss="modal"
      >
        Close
      </button>
      <button
        type="submit"
        [disabled]="!userRoleForm.valid || actionInProgress"
        class="btn"
        [ngClass]="{ 'btn-primary': isAddOrEdit(), 'btn-danger': isRemove() }"
      >
        <span
          *ngIf="actionInProgress"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span *ngIf="isEdit() && !actionInProgress">
          <fa-icon [icon]="faEditPencil"></fa-icon>
        </span>
        <span *ngIf="isRemove() && !actionInProgress" class="oi oi-x"></span>
        {{ getButtonName() }}
      </button>
    </div>
  </form>
</div>
